export class HosTime {
    constructor(data = {}) {
        this.limitTime = data.limitTime ?? 0;           // ms
        this.regulation = data.regulation?.id ?? null;
        this.restartTime = data.restartTime ?? 0;
        this.accumulatedTime = data.accumulatedTime ?? 0;
        this.accumulatedRestartTime = data.accumulatedRestartTime ?? 0;
    }

    /** remaining time in ms */
    get remaining() {
        return Math.max(this.limitTime - this.accumulatedTime, 0);
    }

    /** format ms → "HH:MM" */
    static formatMs(ms) {
        const totalMin = Math.floor(ms / 60000);
        const h = Math.floor(totalMin / 60);
        const m = totalMin % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    }

    get remainingFormatted() {
        return HosTime.formatMs(this.remaining);
    }

    get accumulatedFormatted() {
        return HosTime.formatMs(this.accumulatedTime);
    }

    get limitFormatted() {
        return HosTime.formatMs(this.limitTime);
    }
}

export class HosSettings {
    constructor(data = {}) {
        this.u = data.u ?? false;
        this.us = data.us ?? false;
        this.cycleId = data.cycle?.id ?? null;
        this.exempt = data.exempt ?? false;
        this.cargoTypeId = data.cargoType?.id ?? null;
        this.pcAllowed = data.pcAllowed ?? false;
        this.restBreakId = data.restBreak?.id ?? null;
        this.ymAllowed = data.ymAllowed ?? false;
        this.forceUpdate = data.forceUpdate ?? false;
        this.restartHoursId = data.restartHours?.id ?? null;
    }
}

export class DriverDetail {
    constructor(data = {}) {
        this.id = data.id ?? null;
        this.companyId = data.company_id ?? null;
        this.firstName = data.first_name ?? '';
        this.lastName = data.last_name ?? '';
        this.fullName = data.full_name ?? '';
        this.createdAt = data.created_at ?? null;
        this.email = data.email ?? '';
        this.phoneNumber = data.phone_number ?? '';
        this.appVersion = data.app_version ?? '';
        this.licenseNumber = data.license_number ?? '';
        this.licenseState = data.license_state ?? '';
        this.homeTerminal = data.home_terminal ?? null;
        this.homeTerminalTimezone = data.home_terminal_timezone ?? '';
        this.hosSettings = new HosSettings(data.hos_settings);
        this.assignedVehicleIds = data.assigned_vehicle_ids ?? [];
        this.simCard = data.sim_card ?? null;
        this.tags = data.tags ?? '';

        this.cycleTime = new HosTime(data.cycle_time);
        this.breakTime = new HosTime(data.break_time);
        this.driveTime = new HosTime(data.drive_time);
        this.shiftTime = new HosTime(data.shift_time);

        this.lastSeen = data.last_seen ?? null;
        this.os = data.os ?? '';
        this.osVersion = data.os_version ?? '';
        this.connectionStatus = data.connection_status ?? '';
        this.accountId = data.account_id ?? null;
        this.isActive = data.is_active ?? false;
        this.code = data.code ?? '';
        this.locationText = data.location_text ?? '';
        this.vehicleName = data.vehicle_name ?? '';
        this.hasViolations = data.has_violations ?? false;
        this.lastEldDevice = data.last_eld_device ?? '';
        this.updatedAt = data.updated_at ?? null;
        this.hasCertification = data.has_certification ?? false;
        this.username = data.username ?? '';
    }
}
